import { render, staticRenderFns } from "./selectManagedInstruction.vue?vue&type=template&id=1bc4220a"
import script from "./selectManagedInstruction.vue?vue&type=script&lang=js"
export * from "./selectManagedInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports